export default __webpack_public_path__ + "static/media/github.0d6b6239.svg";